import { AUTH_TOKEN_COOKIE } from 'utility/constants';

import { getCookie, hasCookie, removeCookie, setCookie } from './cookieActions';

export const setAuthTokenCookie = (token: string) => {
  setCookie(AUTH_TOKEN_COOKIE, token, {
    // 14 out of 24 hours. I.e., this token expires in 14 hours
    expires: 14 / 24,
  });
};

export const getAuthTokenCookie = () => {
  return getCookie(AUTH_TOKEN_COOKIE);
};

export const hasAuthTokenCookie = () => {
  return hasCookie(AUTH_TOKEN_COOKIE);
};

export const removeAuthTokenCookie = () => {
  removeCookie(AUTH_TOKEN_COOKIE);
};
